import { useTranslation } from 'next-i18next'

import { Link } from '~/components'
import ROUTES from '~/shared/constants/routes.const'

function DonateLink({ className }: { className?: string }): React.ReactElement {
  const { t } = useTranslation('donation')
  return (
    <Link className={`py-1 bg-yellow-golden w-37 tracking-widest rounded ${className}`} to={ROUTES.MATHMAGIC_DONATE}>
      {t('donate')}
    </Link>
  )
}

export default DonateLink
